import { AreaDisplayInfo } from "../../Types/AreaDisplayInfo/AreaDisplayInfo";
import { IProductQuestionnaire } from "../../Types/Products/IProductQuestionnaire";

/** Registered export formats; extend when adding e.g. Word. */
export type ExportFormat = "xlsx" | "docx" | "html";

/** Sheet column keys shared by Excel and Word exports (same labels as sheet headers). */
export const EXPORT_COLS = [
  "Title",
  "Grade",
  "Due date",
  "Owner",
  "Type of template",
  "Completion date",
  "Section",
  "Criteria",
  "Field title",
  "Field content",
  "Tags",
  "Linked evidence files",
] as const;

/** Area-level blocks that are toggleable but not sheet columns. */
export const EXPORT_BLOCKS = [
  "Introduction",
  "Additional information",
] as const;

/** Wizard toggle list: sheet columns plus area-level blocks. */
export const EXPORT_TOGGLES = [...EXPORT_COLS, ...EXPORT_BLOCKS] as const;

export type ExportSheetColumnKey = (typeof EXPORT_COLS)[number];
export type ExportColumnKey = (typeof EXPORT_TOGGLES)[number];

export type ExportFieldVisibility = Record<ExportColumnKey, boolean>;

export const DEFAULT_EXPORT_FIELD_VISIBILITY: ExportFieldVisibility =
  EXPORT_TOGGLES.reduce(
    (acc, k) => ({ ...acc, [k]: true }),
    {} as ExportFieldVisibility
  );

export function fullExportFieldVisibility(
  partial?: Partial<ExportFieldVisibility>
): ExportFieldVisibility {
  return { ...DEFAULT_EXPORT_FIELD_VISIBILITY, ...partial };
}

export type ExportOptions = {
  fieldVisibility?: Partial<ExportFieldVisibility>;
};

export type AreaExportData = {
  /** Requested evaluate area id (route id). */
  areaId: string;
  questionnaire: IProductQuestionnaire;
  /** Optional list metadata (owner, due date, %) when available from the UI. */
  displayInfo?: AreaDisplayInfo;
  /** Linked evidence file names per criteria id (Cosmos questionId). */
  evidenceByCriteriaId: Record<string, string[]>;
};

export type ExporterMeta = {
  label: string;
  extension: string;
  mime: string;
};

/** Produces a downloadable Blob for one or more areas. */
export type IAreaExporter = (
  areas: AreaExportData[],
  baseFilename: string,
  options?: ExportOptions
) => Promise<Blob>;

export type RegisteredExporter = {
  exporter: IAreaExporter;
  meta: ExporterMeta;
};
